import { Route, Routes } from "react-router-dom";
import "./assets/styles/style.css";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import Home from "./pages/home/Home";
import CoursesPage from "./components/layouts/coursespage/CoursesPage";
import YourComponent from "./YourComponent";
import CodeIDE from "./components/layouts/codeIDE/CodeIDE";
import Admin from "./pages/admin/Admin";
import MainLoader from './components/loaders/MainLoader'
import { useEffect, useState } from "react";
// import LandingPage from "./components/layouts/landingpage/LandingPage";
// import { useEffect } from "react";
// import { fetchData } from "./features/questions/questionSlice"; // Import fetchData directly
// import { useDispatch } from "react-redux";
// import { useSelector } from "react-redux"; // Import useSelector

function App() {
  const [loading, setLoading] = useState(false)
  // const dispatch = useDispatch();

  // dispatch(fetchData());
  // useEffect(() => {
  //   dispatch(fetchData({ course: 'javascript', difficulty: 'easy', categories: 'programming' }));
  // }, [dispatch]);

  // const isLoading = useSelector((state) => state.questions.isLoading);
  //  useSelector((state) => state.questions.data); 

  // console.log("Data from Redux store:", data?.[0]);

  // if (isLoading) {
  //   return <div>Loading...</div>;
  // }

  useEffect(() => {
    window.addEventListener("DOMContentLoaded", () => {
      setLoading(true)
    })
    
    return () => {
      window.removeEventListener("DOMContentLoaded", () => {
        setLoading(false)
      })
    }
  }, [])

  return (
    <>
    {loading ? <MainLoader /> :
    <>
      <Header />
      {/* <LandingPage /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/categories/:courseParam?/:difficulty?/:id?" element={<CoursesPage />} />
        <Route path="/dev" element={<YourComponent />} />
        <Route path="/code" element={<CodeIDE />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/*" element={<h1>Page Not Found</h1>} />
      </Routes>
      <Footer />
      </>
    }
    </>
  );
}

export default App;
